import React from 'react';
import { ChevronDoubleDownIcon, ChevronDoubleUpIcon, ChevronDownIcon, ChevronUpIcon, MinusIcon } from '@heroicons/react/16/solid';
import { MarketPaceVerdict } from '@app/model/market_insight/MarketPace';

// The corner mark of a calendar day: the pace verdict as a small chip. In line has no mark.
export const PaceChip: React.FunctionComponent<{ verdict: MarketPaceVerdict }> = ({ verdict }) => {
	switch (verdict) {
		case 'MUCH_FASTER':
			return <span className="inline-flex h-4 w-4 items-center justify-center rounded bg-emerald-600 text-white"><ChevronDoubleUpIcon className="h-3 w-3" aria-hidden="true" /></span>;
		case 'FASTER':
			return <span className="inline-flex h-4 w-4 items-center justify-center rounded bg-emerald-100 text-emerald-700"><ChevronUpIcon className="h-3 w-3" aria-hidden="true" /></span>;
		case 'SLOWER':
			return <span className="inline-flex h-4 w-4 items-center justify-center rounded bg-violet-100 text-violet-700"><ChevronDownIcon className="h-3 w-3" aria-hidden="true" /></span>;
		case 'MUCH_SLOWER':
			return <span className="inline-flex h-4 w-4 items-center justify-center rounded bg-violet-600 text-white"><ChevronDoubleDownIcon className="h-3 w-3" aria-hidden="true" /></span>;
		case 'NO_COMPARISON':
			return <span className="inline-flex h-4 w-4 items-center justify-center text-gray-400"><MinusIcon className="h-3 w-3" aria-hidden="true" /></span>;
		default:
			return null;
	}
};
